export enum PaymentType {
  CASH = 'CASH',
  CUSTOMER_ACCOUNT = 'CUSTOMER_ACCOUNT',
  BANK_CARD = 'BANK_CARD',
  EMPLOYEE_CARD = 'EMPLOYEE_CARD',
}

export enum ProductionType {
  TOTAL = 'PRODUCTION_TOTAL_VALUE',
  ADDITIONAL = 'PRODUCTION_ADDITIONAL_VALUE',
  EXCESS = 'PRODUCTION_EXCESS_VALUE',
}

export interface RevenueReportReqParams {
  from: string;
  to: string;
  dishGroupId?: string;
  paymentType?: PaymentType;
  sortProperty?: string | null;
  desc?: boolean;
}

export interface SubsidyReportReqParams {
  from: string;
  to: string;
  userCompanyId?: string;
  userGroupId?: string;
}

export enum StornoReportComponent {
  ALL = 'ALL',
  SPT = 'SPT',
  CONSUMER = 'CONSUMER',
  SCAN_AND_PAY = 'SCAN_AND_PAY',
}

export interface StornoReportReqParams {
  from: string;
  to: string;
  component?: StornoReportComponent;
}

export interface OrderTipsReportReqParams {
  from: string;
  to: string;
  paymentType?: PaymentType;
}

export interface SubsidyReport {
  discounts: IUserGroupDiscount[];
  companyTitle: string;
  amount: number;
  total: number;
}

export interface IUserGroupDiscount {
  title: string;
  amount: number;
  value: number;
  total: number;
}

export interface RevenueReport {
  categories: ICategoryReport[];
  total: IRevenueReportTotal;
}

export interface ICategoryReport {
  title: string;
  menuItems: IMenuItemReport[];
  total: IReportTotal;
}

export interface IReportTotal {
  amount: number;
  brutto: number;
  vatAmount: number;
  netto: number;
}

export interface IRevenueReportTotal {
  amount: number;
  brutto: number;
  vatAmount: number;
  vatByPercentage: {
    [key: string]: number;
  };
  netto: number;
  discounts: IDiscountTotal;
  bruttoByPercentage: {
    [key: string]: number;
  };
  nettoByPercentage: {
    [key: string]: number;
  };
  receiptsNumber: number;
  selfCheckoutsNumber: number;
}

interface IDiscountTotal {
  number: number;
  amount: number;
}

export interface IMenuItemReport {
  itemNumber: number;
  title: string;
  amount: number;
  price: number;
  brutto: number;
  vat: number;
  vatAmount: number;
  netto: number;
}

export interface StornoReport {
  menuItems: IMenuItemStornoReport[];
  total: IStornoReportTotal;
}

export interface IMenuItemStornoReport {
  itemNumber: number;
  title: string;
  amount: number;
  price: number;
  brutto: number;
  vat: number;
  vatAmount: number;
  netto: number;
  reason: string;
}

export interface IStornoReportTotal {
  amount: number;
  brutto: number;
  vatAmount: number;
  netto: number;
}

export interface IOrderTipsReport {
  date: string;
  allAmount: number;
  cashAmount: number;
  cashBaseVat: number;
  cashReducedVat: number;
  nonCashAmount: number;
  nonCashBaseVat: number;
  nonCashReducedVat: number;
}

export interface SortProperty {
  id: string;
  desc: boolean;
}

export interface IStocklistReport {
  date: string;
  itemTag: string;
  fullAmount: number;
  additionalAmount: number;
  redundantAmount: number;
  changeStockMessage: string;
}

export interface StocklistReportReqParams {
  from: string;
  to: string;
}
